module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp1_9005.dae083e3.png";